export enum WujieBusEnum {
  LOGIN = 'login',
  SYNC_STATE = 'syncState',
}
/**
 * 判断当前应用是否处于无界环境中
 */
export const isInWujie = () => !!(window as any).__POWERED_BY_WUJIE__
